import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  warehouseCode: {
    name: "warehouseCode",
    label: "Warehouse Code",
    type: "select",
    errorMsg: "Warehouse Code is required.",
    required: true,
    xs: 6,
    edit: true,
  },
  zoneID: {
    name: "zoneID",
    label: "Zone ID",
    type: "select",
    errorMsg: "Zone ID is required.",
    required: true,
    xs: 6,
    edit: true,
  },
  rack: {
    name: "rack",
    label: "Rack",
    type: "select",
    errorMsg: "Rack Number is required.",
    required: true,
    xs: 6,
    edit: true,
  },
  skuList: {
    name: "skuList",
    label: "SKU List",
    type: "select",
    xs: 12,
    errorMsg: "SKUs are required.",
    required: true,
    multiple: true,
  },
  locationID: {
    name: "locationID",
    label: "Location ID",
    type: "multi-select",
    errorMsg: "Location IDs are required.",
    xs: 12,
    required: true,
    multiple: true,
  },
  setRouteSequence: {
    name: "setRouteSequence",
    label: "Set Route Sequence",
    type: "switch",
    default: false,
    xs: 6,
    required: true,
  }
};

export const initialValues = getInitialValues(formField);

const { warehouseCode, zoneID, rack, skuList, locationID, setRouteSequence } = formField;

export const formRender = [[warehouseCode, zoneID], [rack, setRouteSequence], [locationID], [skuList]];

export const preferredLocationValidations = Yup.object().shape({
  warehouseCode: Yup.string().nullable().max(20).required(warehouseCode.errorMsg),
  zoneID: Yup.string().nullable().max(20).required(zoneID.errorMsg),
  rack: Yup.string().nullable().max(20).required(rack.errorMsg),
  setRouteSequence: Yup.string().nullable().max(20),
});
